// extracted by mini-css-extract-plugin
export default {"virtuallyHidden":"virtually-hidden_virtuallyHidden__MK7On"};